import { SITE_ORIGIN } from '@/utlis/siteConfig';

/** Guides 列表 — 按日期倒序（最新在前），与飞书文档 Guides 三篇 post 一致 */
export const guidePosts = [
  {
    title: 'How to Pin Chats in GB WhatsApp',
    poster: require('@/assets/guide-pin-chats.webp'),
    desc: 'Keep important conversations easy to find with this GB WhatsApp guide to pinning chats, removing pinned conversations, and managing your chat list.',
    name: 'guide-pin-chats',
    url: `${SITE_ORIGIN}/pin-chats-in-gb-whatsapp/`,
    path: '/pin-chats-in-gb-whatsapp/',
    date: '2026-10-21',
  },
  {
    title: 'How to Download GB WhatsApp Status Videos to Your Phone',
    poster: require('@/assets/guide-status-videos.webp'),
    desc: 'Find out how to save GB WhatsApp status videos to your Android phone, check available media options, and locate status files using your file manager.',
    name: 'guide-status-videos',
    url: `${SITE_ORIGIN}/download-gb-whatsapp-status-videos/`,
    path: '/download-gb-whatsapp-status-videos/',
    date: '2026-10-21',
  },
  {
    title: 'How to Transfer GB WhatsApp to a New Phone',
    poster: require('@/assets/guide-3.png'),
    desc: 'Learn how to transfer GB WhatsApp chats, photos, videos, and files to a new phone with simple backup and restore methods.',
    name: 'guide-transfer',
    url: `${SITE_ORIGIN}/how-to-transfer-gb-whatsapp-to-new-phone/`,
    path: '/how-to-transfer-gb-whatsapp-to-new-phone/',
    date: '2026-07-28',
  },
  {
    title: 'How to Update GB WhatsApp Without Losing Chats',
    poster: require('@/assets/guide-2.png'),
    desc: 'Update GB WhatsApp safely without losing chats, photos, and media files. Follow these steps to backup data and install the latest version.',
    name: 'guide-update',
    url: `${SITE_ORIGIN}/how-to-update-gb-whatsapp-without-losing-chats/`,
    path: '/how-to-update-gb-whatsapp-without-losing-chats/',
    date: '2026-07-28',
  },
  {
    title: 'How to Backup GB WhatsApp Before Updating',
    poster: require('@/assets/guide-1.png'),
    desc: 'Learn how to backup GB WhatsApp chats, photos, videos, and files before updating to a new version without losing your important data.',
    name: 'guide-backup',
    url: `${SITE_ORIGIN}/how-to-backup-gb-whatsapp-before-updating/`,
    path: '/how-to-backup-gb-whatsapp-before-updating/',
    date: '2026-07-28',
  },
];

export default { guidePosts };
